import type {TableDataType} from '../../../../components/table/table-data-type'
import {RoadmapPillAreaColumnId} from '../../helpers/column-ids'
import type {ColumnDef} from '../../helpers/types'

/**
 * Non-field Tanstack table column definition for the right-side pill area in the Roadmap view
 */
export const RoadmapPillAreaColumnDef: ColumnDef<TableDataType> = {
  id: RoadmapPillAreaColumnId,
  accessorKey: RoadmapPillAreaColumnId,
  size: 50,
  minSize: 50,
  enableResizing: false,
  meta: {
    columnModel: undefined,
    Cell: () => null,
    nonNavigable: false,
    typeToEditEnabled: false,
  },
}
